// The base API url for taxplan.api
export const baseAPIUrl = import.meta.env.VITE_API_URL;
export const googleAPIKey = import.meta.env.VITE_GOOGLE_API_KEY;

// Jwt specific data
export const jwtData = {
  refreshUrl: "admin/refreshToken",
  authToken: "authToken",
  refreshToken: "refresh_token",
  tokenExpiry: "tokenExpiry",
  refreshExpiry: "refreshExpiry",
};

export const crypto = {
  temporaryPasswordByteSize: 256,
};

export const awsData = {
  awsKey: import.meta.env.VITE_AWS_KEY,
  awsSecret: import.meta.env.VITE_AWS_SECRET,
  awsBucket: import.meta.env.VITE_AWS_BUCKET || "",
  awsRegion: import.meta.env.VITE_AWS_REGION || "ca-central-1",
  awsSignatureVersion: import.meta.env.VITE_AWS_VERSION || "v4",
};
